import React, { ReactNode } from 'react';
import classnames from 'classnames';
export interface ButtonProps {
  testId?: string;
  fill?: 'fill' | 'outline' | 'transparent';
  type?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'dark'
    | 'light'
    | 'info';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  children?: string | JSX.Element | JSX.Element[] | ReactNode;
  disabled?: boolean;
  isPadding?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  block?: boolean;
  htmlType?: 'button' | 'submit';
  loading?: boolean;
}

export const Button = ({
  testId,
  fill = 'fill',
  type = 'default',
  size = 'md',
  className = '',
  children,
  disabled,
  block = false,
  htmlType = 'button',
  loading = false,
  isPadding = true,
  ...props
}: ButtonProps) => {
  return (
    <button
      data-testid={testId}
      disabled={disabled || loading}
      type={htmlType}
      className={classnames(className, 'btn gap-4', {
        [`btn-${size}`]: size,
        [`btn-${type}-fill`]: fill === 'fill',
        [`btn-${type}-outline`]: fill === 'outline',
        [`btn-${type}-transparent`]: fill === 'transparent',
        ['display-block']: block,
        'p-0': !isPadding,
        'btn-transition': !disabled,
        'btn-active': !disabled,
      })}
      {...props}
    >
      {loading && (
        <div className="btn-rotate d-flex align-items-center">
          <svg
            viewBox="0 0 1024 1024"
            focusable="false"
            data-icon="loading"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
          </svg>
        </div>
      )}
      {children}
    </button>
  );
};
